import { BaseInput, BaseTextArea } from "@/components/input/CustomInputs";
import { formInterface } from "@/interface/dataInterface";
import { FC } from "react";

const ClientFormCommon: FC<formInterface> = ({ formProp, setFormProp }) => (
  <div className="grid grid-cols-2 gap-5">
    <BaseInput
      id="name"
      label="Full name"
      value={formProp.name}
      setProp={setFormProp}
      placeholder="Client full name"
    />
    <BaseInput
      id="phone"
      label="Phone number"
      value={formProp.phone}
      setProp={setFormProp}
      placeholder="Client phone number"
    />
    <div className="col-span-2">
      <BaseInput
        id="email"
        label="Email"
        value={formProp.email}
        setProp={setFormProp}
        type="email"
      />
    </div>
    {/* <div className="col-span-2">
      <BaseTextArea
        id="notes"
        label="Notes"
        value={formProp.notes}
        setProp={setFormProp}
      />
    </div> */}
  </div>
);

export default ClientFormCommon;
